import axios from "../../../../../axios";
import Cookies from "js-cookie";

export const GetAllOfferReleasedCandidate = async () => {
  const token = Cookies.get("employeeToken");

  return axios.post("/api/Candidate/GetOfferRelesedCandidates", {
    token,
  });
};
